import { createSelector } from 'reselect';
import { civilSectionsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const civilSectionsYearsSelector = createSelector([civilSectionsSelector], (civilSections) =>
  extractDatesFromNestedItems(
    [civilSections.content],
    [
      {
        type: 'range',
        startField: 'startDate',
        endField: 'endDate',
      },
    ],
  ),
);
